import React from 'react';
import { Typography, Box } from '@mui/material';
import noDataImage from '../../assets/images/gallery/nodata.png'; 

const NoDataPage = () => {
  return (
    <Box
      sx={{
        textAlign: 'center', 
        padding: '40px', 
        display: 'flex',
        flexDirection: 'column', 
        alignItems: 'center',
        justifyContent: 'center',
        height: '50vh',
        // backgroundColor: '#f9f9f9',
        // marginLeft: '27%',
      //  marginTop:"-11%"
      marginBottom: "5%"
      }}
    >
      <Box
        component="img"
        src={noDataImage}
        alt="No Data"
        sx={{
          width: '300px', 
          marginBottom: '20px', 
        }}
      />
    </Box>
  );
};

export default NoDataPage;
